import { Routes } from '@angular/router';
import { ReviewsComponent } from '@app/layouts/admin/reviews/reviews';

export const adminChildRoutes: Routes = [
  {
    path: 'reviews',
    component: ReviewsComponent,
  },
  { path: '**', redirectTo: 'reviews' },
];
